import { ProvincesShortCode } from "../Components/navigationTypes";

export const adMapper: Record<string, string> = {
    "ad_dashboard": "ad1-Dashboard",
    "InFile_2": "ad2-ClientConnect-infile",
    "InFile_3": "ad3-MyDrive-infile",
    "InFile_1": "ad4-RenAI-infile",
    "InFile_4": "ad5-Realti-infile",
    "Splash2": "ad6-Realti-splash",
    "Splash1": "ad7-E-sign"
}

export const RPWPropertyType: Record<ProvincesShortCode, Record<string, string>> = {
    "ON": {
        "Freehold": "Freehold (Fee Simple)",
        "Condo": "Condominium (Freehold)"
    },
    "AB": {
        "Freehold": "Freehold (Fee Simple)",
        "Condo": "Condominium (Freehold)",
        "Leasehold": "Leasehold",
        "Subleasehold": "Subleasehold",
        "CondoSubleasehold": "Condominium (Subleasehold)"
    },
    "MB": {
        "Freehold": "Freehold (Fee Simple)",
        "Condo": "Condominium (Freehold)"
    },
    "SK": {
        "Freehold": "Freehold (Fee Simple)",
        "Condo": "Condominium (Freehold)"
    },
    "BC": {
        "Freehold": "Freehold (Non-Strata)",
        "Condo": "Strata (Fee Simple)",
        "Leasehold": "Leasehold (Non-Strata)"
    },
    "NS": {
        "Freehold": "Freehold (Fee Simple)",
        "Condo": "Condominium (Freehold)"
    }
}

export default RPWPropertyType